// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingScreen_root__2p6rH","inner":"LoadingScreen_inner__3N6LI","loadingImg":"LoadingScreen_loadingImg__2Z5Wa","loadingMsg":"LoadingScreen_loadingMsg__2tO3N"};